import { jsPDF } from "jspdf";

export const exportToCSV = (data, filename = 'export.csv') => {
  if (!data || !data.length) return;
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row => headers.map(header => {
      const cell = row[header] === null || row[header] === undefined ? '' : row[header];
      return `"${String(cell).replace(/"/g, '""')}"`;
    }).join(','))
  ].join('\n');
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

// Helper to add colored headers
const addHeader = (doc, title, y) => {
  doc.setFillColor(41, 128, 185); // Blue
  doc.rect(0, y - 6, 210, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(title, 10, y);
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "normal");
  return y + 15;
};

// Internal generator logic
const createPDFDoc = (assessment) => {
  const doc = new jsPDF();
  let y = 20;

  // -- TITLE PAGE --
  doc.setFillColor(59, 130, 246); // Tailwind Blue-500
  doc.rect(0, 0, 210, 40, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont("helvetica", "bold");
  doc.text("Organizational Health Report", 105, 25, { align: "center" });
  
  y = 60;
  
  // -- SUMMARY --
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text(`Organization: ${assessment.userInfo.orgCode}`, 20, y);
  y += 8;
  doc.text(`Prepared For: ${assessment.userInfo.name}`, 20, y);
  y += 8;
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 20, y);
  y += 15;

  doc.setFontSize(16);
  doc.setTextColor(59, 130, 246);
  doc.text(`Overall Score: ${assessment.score || 0}`, 20, y);
  y += 20;

  // -- DETAILED RESPONSES --
  y = addHeader(doc, "Assessment Responses", y);
  
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);

  const responseKeys = Object.keys(assessment.responses || {});
  
  responseKeys.forEach((key) => {
    // Check page break
    if (y > 270) {
      doc.addPage();
      y = 20;
      y = addHeader(doc, "Assessment Responses (Cont.)", y);
      doc.setFontSize(10);
    }

    // Format Key (e.g., vision_0 -> Vision Q1)
    const [area, idx] = key.split('_');
    const displayKey = `${area.charAt(0).toUpperCase() + area.slice(1)} Q${parseInt(idx) + 1}`;
    const value = assessment.responses[key];

    doc.setFont("helvetica", "bold");
    doc.text(`${displayKey}:`, 20, y);
    doc.setFont("helvetica", "normal");
    doc.text(`${value}/7`, 80, y);
    
    y += 7;
  });

  // -- ABOUT YOU --
  if (assessment.aboutYou) {
    if (y > 250) {
      doc.addPage();
      y = 20;
    } else {
      y += 10;
    }
    
    y = addHeader(doc, "Organization Context", y);
    doc.setFontSize(10);
    
    Object.entries(assessment.aboutYou).forEach(([key, value]) => {
        if (!value || typeof value !== 'string') return;
        
        if (y > 270) {
            doc.addPage();
            y = 20;
        }

        doc.setFont("helvetica", "bold");
        doc.text(`${key}:`, 20, y);
        
        // Handle long text wrapping
        doc.setFont("helvetica", "normal");
        const lines = doc.splitTextToSize(String(value), 120);
        doc.text(lines, 80, y);
        
        y += (lines.length * 5) + 4;
    });
  }

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150);
    doc.text(`Page ${i} of ${pageCount} - Generated by Wendworks`, 105, 290, { align: "center" });
  }

  return doc;
};

// Generates and downloads the PDF immediately
export const generateUserReportPDF = (assessment) => {
  const doc = createPDFDoc(assessment);
  doc.save(`Report_${assessment.userInfo.name.replace(/\s+/g, '_')}.pdf`);
};

// Generates and returns a Blob (for uploading)
export const generateReportBlob = (assessment) => {
  const doc = createPDFDoc(assessment);
  return doc.output('blob');
};